import { createContext } from 'react';

/** Portal target for the dictation button: undefined — no hosting title row (Textarea floats the button itself); null — a title row is mounting, its node is not ready yet (render nothing). */
export const DictationButtonSlotContext = createContext<HTMLElement | null | undefined>(undefined);
